<div class="cpp-content-intuo">
  <div class="cpp-heading">
    <div class="cpp-heading__content">
      <span class="cpp-heading__title">{{ labels['intuo.title'] }}</span>
    </div>
  </div>

  <p>{{firstDescriptionOne}} <br/><br/>
    <span *ngIf="!hasDoceboPermission">
      {{this.getBeginningOfSentence(firstDescriptionTwo)}}  
      <a target="_blank" [href]="redirectCatalogUrl">{{this.getMiddleOfSentence(firstDescriptionTwo)}}</a>
      {{this.getEndOfSentence(firstDescriptionTwo)}} <br/><br/>
    </span>
    {{this.getBeginningOfSentence(firstDescriptionThree)}} 
    <a target="_blank" href="mailto:{{email}}">{{getMiddleOfSentence(firstDescriptionThree)}}</a>
    {{this.getEndOfSentence(firstDescriptionThree)}}
  </p>

  <!-- <div class="spotlight-container" style="display: flex; flex-direction: column; gap: 20px;">
    <div class="spotlight">
      <a class="cpp-button cpp-button--lg cpp-button--action"
        target="intuo"
        [href]="redirectUrl">
        <button class="cpp-button-access-platform"><b>{{ labels['intuo.button'] }}</b></button>
      </a>
    </div>
    <span *ngIf="hasDoceboPartnerPermission">
    <div class="spotlight">
      <a class="cpp-button cpp-button--lg cpp-button--action"
        target="intuo"
        [href]="redirectUrlPartner">
        <button class="cpp-button-access-platform"><b>{{ labels['docebo.partner.button'] }}</b></button>
      </a>
    </div>
  </span>
  </div> -->

  <div class="spotlight-container" style="display: flex; flex-direction: column; gap: 30px;">
  
    <!-- Shown only when the user does NOT have partner permission -->
    <div class="spotlight" *ngIf="!hasDoceboPartnerPermission">
      <a class="cpp-button cpp-button--lg cpp-button--action"
         target="intuo"
         [href]="redirectUrl">
        <button class="cpp-button-access-platform"><b>{{ labels['intuo.button'] }}</b></button>
      </a>
    </div>
  
    <!-- Shown only when the user HAS partner permission -->
    <div class="spotlight" *ngIf="hasDoceboPartnerPermission">
      <!-- First button (same as original) -->
      <a class="cpp-button cpp-button--lg cpp-button--action"
         target="intuo"
         [href]="redirectUrlPartner">
        <button class="cpp-button-access-platform"><b>{{ labels['docebo.partner.button'] }}</b></button>
      </a>
    </div>
    <div class="spotlight" *ngIf="hasDoceboPartnerPermission">
      <a class="cpp-button cpp-button--lg cpp-button--action"
         target="intuo"
         [href]="redirectUrl">
        <button class="cpp-button-access-platform"><b>{{ labels['intuo.legacy.button'] }}</b></button>
      </a>
    </div>
  </div>
  

  <div class="banner-image"></div>

  <p>{{ secondDescriptionOne }} <br/><br/>
    {{this.getBeginningOfSentence(secondDescriptionTwo)}}
    <a target="_blank" [href]="norske">{{this.getMiddleOfSentence(secondDescriptionTwo)}}</a> <br/>
    {{this.getBeginningOfSentence(secondDescriptionThree)}}
    <a target="_blank" [href]="svensk">{{this.getMiddleOfSentence(secondDescriptionThree)}}</a>
  </p>
</div>